import { whitelistApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_WHITELIST_ACTION_TYPE = createNamedActions('companyWhitelist', {
  GET_WHITELISTS: 'GET_WHITELISTS',
  ADD_WHITELISTS: 'ADD_WHITELISTS',
  REMOVE_WHITELISTS: 'REMOVE_WHITELISTS',
});

export const getWhitelistsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await whitelistApi.getWhitelists(params);

  return dispatch({
    type: COMPANY_WHITELIST_ACTION_TYPE.GET_WHITELISTS,
    payload: data,
  });
});

export const createWhitelistsAction = catchAsyncActionError(whitelists => async dispatch => {
  const { data } = await whitelistApi.createWhitelists(whitelists);

  return dispatch({
    type: COMPANY_WHITELIST_ACTION_TYPE.ADD_WHITELISTS,
    payload: data,
  });
});

export const deleteWhitelistsAction = catchAsyncActionError(whitelists => async dispatch => {
  await whitelistApi.deleteWhitelists(whitelists);

  return dispatch({
    type: COMPANY_WHITELIST_ACTION_TYPE.REMOVE_WHITELISTS,
    payload: whitelists,
  });
});
